let lenis;

class Common {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){

    // 幅が768px以上のビューポートをターゲットとするメディアクエリを作成
    const sp = window.matchMedia('(max-width: 767px)')

    if (!sp.matches) {
      lenis = new Lenis({
        duration: 0.4, // スクロールアニメーションの時間
      });

      function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
      }
      
      requestAnimationFrame(raf);
    }

    $('.js-drawer').click(function() {
      $('html').toggleClass('is-drawer');

      if($('html').hasClass('is-drawer')) {
        setTimeout(() => {
          let stop = !sp.matches ? lenis.stop() : scrollBan();
        }, 700);
      } else {
        let stop = !sp.matches ? lenis.start() : scrollBan();
      }
    })
    // メディアクエリがtrueかどうかをチェック
    if (sp.matches) {
      $('.js-accordion-inner').hide();
    }

    $('.js-accordionTrigger').click(function() {
      $(this).toggleClass('is-active');
      $(this).parent().next().slideToggle();
    })

    // **************************************
    // ローディング
    // **************************************

    setTimeout(() => {
      $('.js-loading').addClass('is-active');
      mvTl.play()
    }, 1000);

    // **************************************
    // ローディング
    // **************************************

    if($('.js-mv-primary').length) {
      $('.js-loadingBottom').addClass('is-view');
      $('.js-loadingBottom-display').animate({'opacity': '0'}, 0);
      setTimeout(() => {
        $('.js-loadingBottom').addClass('is-active');
        $('.js-fvImg').animate({'opacity': '1'}, 0);
        setTimeout(() => {
          $('.js-loadingBottom-ttl').addClass('is-inview');
          setTimeout(() => {
            $('.js-loadingBottom-lineTxt').addClass('is-inview');
            $('.js-loadingBottom-display').animate({'opacity': '1'}, 500);
            $('.js-loadingBottom-display').addClass('is-view');
          }, 500);
        }, 500);
      }, 500);
    }
  }
}
